import {
  CATEGORY2_ID_BUS,
  CATEGORY2_ID_CARAVAN,
  CATEGORY2_ID_CLASSIC,
  CATEGORY2_ID_TRUCK,
  CATEGORY2_ID_VAN,
  CATEGORY2_ID_WITHOUT_DRIVING_LICENSE
} from './ads.js'
import {PTA_OTHER_CATEGORIES_PATH_PATTERN, PTA_WITH_PLATE_PATH_PATTERN} from './page.js'
export const LAST_INSTANT_OFFER_DETAILS_KEY = 'lastInstantOfferDetails'
export const VEHICLE_STANDALONE_DRAFT_KEY = 'vehicleStandaloneDraftCoches'

export const IS_AI_GENERATED_COMMENTS_FEATURE_ENABLED = true
export const IS_INSTANT_OFFER_FEATURE_ENABLED = true
export const IS_PRICE_RECOMMENDER_FEATURE_ENABLED = true
export const IS_PANEL_APPRAISAL_FEATURE_ENABLED = true
export const IS_PANEL_EDITORIAL_FEATURE_ENABLED = true
export const IS_PAYMENT_AD_INFORMED_AT_PUBLISH_MY_AD_FORM = true
export const IS_VISIBILITY_PRODUCTS_DYNAMIC_PRICING_FEATURE_ENABLED = true
export const IS_VISIBILITY_PRODUCT_PACK_FEATURE_ENABLED = true

export const RECOMMENDED_NUMBER_OF_UPLOADED_IMAGES = 5

export const SEMANTIC_SELLER_LOCATIONS_MAPPING = {
  madrid: {slug: 'madrid', label: 'Madrid'},
  barcelona: {slug: 'barcelona', label: 'Barcelona'},
  zaragoza: {slug: 'zaragoza', label: 'Zaragoza'},
  valencia: {slug: 'valencia', label: 'Valencia'},
  sevilla: {slug: 'sevilla', label: 'Sevilla'},
  malaga: {slug: 'malaga', label: 'Málaga'},
  murcia: {slug: 'murcia', label: 'Murcia'},
  ciudadReal: {slug: 'ciudad-real', label: 'Ciudad Real'},
  cornella: {slug: 'cornella', label: 'Cornellà'},
  mallorca: {slug: 'mallorca', label: 'Mallorca'},
  vigo: {slug: 'vigo', label: 'Vigo'},
  albacete: {slug: 'albacete', label: 'Albacete'},
  tenerife: {slug: 'tenerife', label: 'Tenerife'},
  lasPalmas: {slug: 'las-palmas', label: 'Las Palmas'},
  jerez: {slug: 'jerez', label: 'Jerez'},
  cordoba: {slug: 'cordoba', label: 'Córdoba'},
  santander: {slug: 'santander', label: 'Santander'},
  asturias: {slug: 'asturias', label: 'Asturias'}
}

export const BENEFITS_CARDS_TABS = {
  BENEFITS_OF_SELLING_TO_PROFESSIONAL: 1,
  BENEFITS_OF_SELLING_TO_PRIVATE: 2
}

export const TOP_AD_PRODUCT_ID = `2`
export const QUICK_SALE_PRODUCT_ID = `10`
export const PACK_VISIBILITY_PRODUCT_ID = `28`

export const USER_AD_VISIBILITY_PRODUCT_CODES = {
  TOP_AD: 'TOP',
  QUICK_SALE: 'QUICK'
}

export const USER_AD_CATEGORIES = {
  CAR: 'CAR',
  INDUSTRIAL: 'INDUSTRIAL',
  CLASSIC: 'CLASSIC',
  CARAVAN: 'CARAVAN',
  MICROCAR: 'MICROCAR'
}

export const USER_AD_CATEGORY_RESOURCES = {
  [USER_AD_CATEGORIES.CAR]: 'cars',
  [USER_AD_CATEGORIES.INDUSTRIAL]: 'industrials',
  [USER_AD_CATEGORIES.CLASSIC]: 'classics',
  [USER_AD_CATEGORIES.CARAVAN]: 'caravans',
  [USER_AD_CATEGORIES.MICROCAR]: 'microcars'
}

export const DEFAULT_USER_AD_CATEGORY = USER_AD_CATEGORIES.CAR

export const USER_AD_CATEGORIES_WITH_DRAFT = [USER_AD_CATEGORIES.CAR]

export const USER_AD_CATEGORIES_WITH_INSTANT_OFFER = [USER_AD_CATEGORIES.CAR]

export const USER_AD_CATEGORIES_WITH_CONTENT_SHARING = [USER_AD_CATEGORIES.CAR]

export const USER_AD_CATEGORIES_WITH_REQUIRED_LOGIN = [
  USER_AD_CATEGORIES.INDUSTRIAL,
  USER_AD_CATEGORIES.CLASSIC,
  USER_AD_CATEGORIES.CARAVAN,
  USER_AD_CATEGORIES.MICROCAR
]

export const EDIT_MY_AD_OTHER_CATEGORIES = [
  USER_AD_CATEGORIES.INDUSTRIAL,
  USER_AD_CATEGORIES.CLASSIC,
  USER_AD_CATEGORIES.CARAVAN,
  USER_AD_CATEGORIES.MICROCAR
]

export const VEHICLE_CATEGORIES = [
  {
    description: `COMMON.CATEGORIES.CAR_DESCRIPTION`,
    image: `form/publishAd/navigation-coche4x4.png`,
    title: `COMMON.CATEGORIES.CAR`,
    url: PTA_WITH_PLATE_PATH_PATTERN
  },
  {
    description: `COMMON.CATEGORIES.COMMERCIAL_LONG`,
    image: `form/publishAd/navigation-furgoneta.png`,
    title: `COMMON.CATEGORIES.VAN`,
    url: `${PTA_OTHER_CATEGORIES_PATH_PATTERN}?Section2=${CATEGORY2_ID_VAN}`
  },
  {
    description: `COMMON.CATEGORIES.AUTOCARAVAN_DESCRIPTION`,
    image: `form/publishAd/navigation-autocaravanaORemolque.png`,
    title: `COMMON.CATEGORIES.AUTOCARAVAN`,
    url: `${PTA_OTHER_CATEGORIES_PATH_PATTERN}?Section2=${CATEGORY2_ID_CARAVAN}`
  },
  {
    image: `form/publishAd/navigation-clasicoODeCompeticion.png`,
    title: `COMMON.CATEGORIES.CLASSIC_OR_COMPETITION`,
    url: `${PTA_OTHER_CATEGORIES_PATH_PATTERN}?Section2=${CATEGORY2_ID_CLASSIC}`
  },
  {
    image: `form/publishAd/navigation-vehiculoIndustrial.png`,
    title: `COMMON.CATEGORIES.TRUCK`,
    url: `${PTA_OTHER_CATEGORIES_PATH_PATTERN}?Section2=${CATEGORY2_ID_TRUCK}`
  },
  {
    image: `form/publishAd/navigation-cochesSinCarnet.png`,
    title: `COMMON.CATEGORIES.CAR_WITHOUT_LICENSE`,
    url: `${PTA_OTHER_CATEGORIES_PATH_PATTERN}?Section2=${CATEGORY2_ID_WITHOUT_DRIVING_LICENSE}`
  },
  {
    image: `vehicles/bus@2x.png`,
    title: `COMMON.CATEGORIES.BUS`,
    url: `${PTA_OTHER_CATEGORIES_PATH_PATTERN}?Section2=${CATEGORY2_ID_BUS}`
  },
  {
    categoryTitle: `PUBLISH_AD.MILANUNCIOS_AVAILABLE_TITLE`,
    categoryTitleImage: `common/logos/milanuncios-logomark.svg`,
    image: `form/publishAd/navigation-accesorio.png`,
    title: `COMMON.PLURALS.ACCESSORY`,
    url: `https://www.milanuncios.com/publicar-anuncios-gratis/?cat=47`
  }
]

export const VEHICLE_CATEGORIES_ASIDE_ILLUSTRATION = `illustrations/welcome.svg`
